<template>
<div v-if="computeUserAccess && hasTalks">

<divider title="language.divider_todo"/>

      <page-padding>
        <div v-if="!hasTalks">{{$t('language.no_teacher_talks')}}</div>
       
        <!--<button-action v-for="(item,index) in teacher_talks" :key="index" :title='"[todo]inplannen "+item.name' :to='"group/"+item.id+"/planconversation/"'>{{item}}</button-action>-->
       <div class="featured-container">
        
        <featured-button :key="index" v-for='(item,index) in sliceArray(teacher_talks["0featured"],4)' :iconLeft="getIcon(item)" :iconBg="getIconColor(item)" iconRight="" :title="item.name" :subtitle="item.planned" @click.native="goToTalk(item)"/>
       </div>

        <button-more v-if="computeMoreAccess && hasTalks" title="language.view_more_talks" to="/talks/"/>
       </page-padding>
</div>

</template>

<script>

//import ScrollMenu from '../scrollMenu/ScrollMenu.vue';
import { mapState } from 'vuex';
import { USER_LEVEL } from '../../settings/USER_LEVEL.js';
import Divider from '../../components/dividers/Divider.vue';
import FeaturedButton from '../../components/buttons/FeaturedButton.vue';
import PagePadding from '../../components/PagePadding.vue';
import ButtonMore from '../../components/buttons/ButtonMore.vue';

export default {
  name: 'featured-talks',
  props:{
    group_id:{default:0}
  },
  data(){
    return {
     
    }
  },
  computed:{
     ...mapState([
       'teacher_talks','appSettings'
       ]),
       computeUserAccess(){
         if (this.appSettings.user_level==USER_LEVEL.PARENT){
           return true;
         }
         if (this.appSettings.user_level==USER_LEVEL.TEACHER){
           return true;
         }
         if (this.appSettings.user_level==USER_LEVEL.STUDENT){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.ADMIN){
           return true;
         }
         return false;
       },
       computeMoreAccess(){
         if (this.appSettings.user_level==USER_LEVEL.PARENT){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.TEACHER){
           return true;
         }
         if (this.appSettings.user_level==USER_LEVEL.STUDENT){
           return false;
         }
         if (this.appSettings.user_level==USER_LEVEL.ADMIN){
           return true;
         }
         return false;
       },
       hasTalks:function(){
         if(this.teacher_talks["0featured"]){
           return this.teacher_talks["0featured"] ? this.teacher_talks["0featured"].length : false
         }else{
           return false;
         }
       }
  },
  components:{
    Divider,
    FeaturedButton,
    PagePadding,
    ButtonMore,
  },
  methods:{
    sliceArray(arr,count){
      if(arr){
        return arr.slice(0,count)
      }else{
        return [];
      }
    },
    getIcon(item){

        if (this.appSettings.user_level==USER_LEVEL.PARENT){
          var allPlanned = this.checkAllChildrenPlanned(item)
          return allPlanned ? 'check' : 'exclamation';
        }

    },
    checkAllChildrenPlanned(item){
      
      var allPlanned = true;
      if(!item.children){
        
        return false;
      }

      item.children.forEach((child)=>{
        if(!child.time){
          allPlanned=false;
        }
      })

      return allPlanned;
    },
    getIconColor(item){
      if (this.appSettings.user_level==USER_LEVEL.PARENT){
        var allPlanned = this.checkAllChildrenPlanned(item)
        return allPlanned ? '#8cc63e' : '#f46767';
      }
      return 'transparent';
    },
    loadTeacherTalks(){
       this.$store.dispatch('get_teacher_talks',{store_key:"0featured",talk_id:0});
    },
    goToTalk(item){
      //this.$router.push("/group/"+item.group_id+"/talk/"+item.talk_id+"/view/")
      this.$router.push('/group/'+item.group_id+'/talks/'+item.talk_id);
      
    }
   
  },
  mounted:function(){
    this.loadTeacherTalks();
  },
  beforeDestroy(){
   
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.talk-button{
  text-align:center;
  border:1px solid grey;
  display: inline-block;
  flex:1;
  padding:10px 5px;
  cursor:pointer;
  margin:2px;
}
/*
.featured-container:first-child{
  
  border-top: 1px solid #DDDDDD;
  margin-top:15px;
}
*/
.featured-container:last-child{
  margin-bottom:15px;
}
</style>
